import { END_TO_END_STARTER_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { HubEdition } from 'onboarding-scopes/scopeConstants';
export const inferFreeOrStarterTierFromGroupKey = (groupKey = '') => {
  const isStarter = Object.values(END_TO_END_STARTER_GROUP_KEYS).includes(groupKey);
  return isStarter ? HubEdition.STARTER : HubEdition.FREE;
};